var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 911,
    viewBox: "0 0 1920 911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.028,
    y1: -0.04,
    x2: -0.017,
    y2: 1.625,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031527",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1144",
    "data-name": "Rectangle 1144",
    width: 1920,
    height: 911,
    transform: "translate(0 70)",
    opacity: 0.504,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.028,
    y1: -0.04,
    x2: -0.016,
    y2: 1.082,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#158aff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(0 -70)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 1920,
    height: 1080,
    transform: "translate(0 70)",
    opacity: 0.504,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    transform: "matrix(-0.951, -0.309, 0.309, -0.951, 1994.531, 722)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 748.395,
    cy: 748.395,
    r: 748.395,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 748.395,
    cy: 748.395,
    r: 747.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    transform: "matrix(-0.951, -0.309, 0.309, -0.951, 478.839, 1062)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 748.395,
    cy: 748.395,
    r: 748.395,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 748.395,
    cy: 748.395,
    r: 747.895,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage);
export default __webpack_public_path__ + "static/media/BannerImage.54c895783a99f0eb7230136c478547e5.svg";
export { ForwardRef as ReactComponent };